import "./Marketplace.scss";
import React from "react";
import Store from "../Store/Store";
import SelectFilter from "../SelectFilter/SelectFilter";
import AnchorLink from "../AnchorLink/AnchorLink";
import PlainAnchorLink from "../AnchorLink/PlainAnchorLink";
class Marketplace extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      jsonData: props.jsonData,
      filtered: props.filtered,
      filterTypes: ["Geography", "Product Category"],
      filters: props.filters
        ? props.filters
        : {
            Geography: null,
            "Product Category": null,
          },
    };
    this.storesFiltered = this.storesFiltered.bind(this);
    this.storeTagFiltered = this.storeTagFiltered.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
  }
  render() {
    return (
      <div className="container-fluid">
        <section className="fullBlock header" id="marketplace">
          <div className="ctaBlock">
            <h1>
              Open For
              <br />
              Business
            </h1>
            <p>
              From savory goods to sweet treats, Brewing the American Dream
              entrepreneurs have delicious offerings for everyone! Our
              Marketplace is your one-stop shop in connecting with these small
              businesses and supporting their growth. From coast to coast, these
              food and beverage entrepreneurs all ship nationally, ready to send
              their goods right to your door. Check back as we will continually
              update and add more entrepreneurs in our Marketplace.{" "}
            </p>
          </div>
        </section>
        <section className="row align-items-center" id="filterSection">
          {/*           <div className="marketCallout">
            <h2>Sam Adams Baking the American Dream Kit</h2>
            <p>
              Support small businesses with our custom kit that gives you
              everything you need to make your very own delicious cookies! A
              custom cookie recipe featuring Sam Adams Winter Lager, dry
              ingredients from Hot Bread Kitchen of New York, NY, seasonal spice
              blend from Colonel De of Cincinnati, Ohio, and more essentials,
              dont miss out on this holiday treat!
            </p>
            <a
              href="https://checkout.square.site/buy/QIPBXR4FOMDCSWFKGEBQZV34"
              target="_blank"
              rel="noreferrer"
              className="btn btn-primary btn-red"
            >
              BUY NOW
            </a>
          </div> */}
          <div className="filters">
            {this.renderSelectFilters(
              this.state.jsonData,
              "Geography",
              this.state.filters["Geography"]
            )}

            {this.renderSelectFilters(
              this.state.jsonData,
              "Product Category",
              this.state.filters["Product Category"]
            )}
          </div>
          <div className="clearFiltersButton row">
            <button
              className="btn btn-primary btn-red filter"
              onClick={this.clearFilters}
            >
              View All
            </button>
          </div>
        </section>
        <section className="row align-items-center" id="storeWindow">
          <div className="marketPlace col-10 mx-auto">
            <div className="row align-items-center">
              {this.renderStores(this.state.filtered)}
              {this.renderEmpty()}
            </div>
          </div>
          <div className="anchorLinkDiv row">
            <PlainAnchorLink
              href="#filterSection"
              className="scrollToTop btn btn-primary btn-red"
            >
              Scroll To Top
            </PlainAnchorLink>
          </div>
        </section>

        <AnchorLink
          href="#filterSection"
          className="scrollToVeryTop"
          opactityid="filterSection"
        >
          <h2>{">"}</h2>
        </AnchorLink>
      </div>
    );
  }
  renderEmpty() {
    var message = "";
    if (this.state.filtered.length < 1) {
      message =
        "We're sorry, but we didn't find any program participants in this search criteria.";
    }
    return (
      <div className="nothingFound">
        <h3>{message}</h3>
      </div>
    );
  }
  clearFilters() {
    this.setState({
      filtered: this.state.jsonData,
      filters: {
        Geography: null,
        "Product Category": null,
      },
    });
  }
  renderStores(stores) {
    return stores.map((store) => this.renderStore(store));
  }
  renderStore(store) {
    return (
      <Store
        key={store["Business Name"]}
        storeData={store}
        onClickedTag={this.storeTagFiltered}
      />
    );
  }
  renderSelectFilters(stores, type, selected) {
    const geo = ["View All"];
    stores.forEach((element) => {
      if (element[type]) {
        if (Array.isArray(element[type])) {
          element[type].forEach((e) => {
            geo.push(e);
          });
        } else {
          geo.push(element[type]);
        }
      }
    });
    const uniqueGeo = [...new Set(geo)];
    return (
      <SelectFilter
        options={uniqueGeo}
        type={type}
        label={type}
        onFilterSelection={this.storeTagFiltered}
        selected={selected}
      />
    );
  }
  storesFiltered(compState) {
    if (compState.filter === "View All") {
      compState.filter = null;
    }
    const filters = this.state.filters;
    filters[compState.type] = compState.filter;

    var filtered = this.state.jsonData;
    this.state.filterTypes.forEach((f) => {
      const v = {
        type: f,
        filter: filters[f],
      };
      filtered = this.getFilteredData(filtered, v);
    });
    this.setState({
      filtered: filtered,
      filters: filters,
    });
  }
  getFilteredData(data, filter) {
    return filter && filter.filter
      ? data.filter((store) =>
          Array.isArray(store[filter.type])
            ? store[filter.type].includes(filter.filter)
            : store[filter.type] === filter.filter
        )
      : data;
  }
  storeTagFiltered(e) {
    this.storesFiltered(e);
  }
}

export default Marketplace;
